import React from 'react';
import { useTranslation } from 'react-i18next';

import { CssModuleType } from '@utils/cssModules';

import currentCssModule from './ToolbarTopDesktop.module.scss';
import SelectWithLabels from '../../kit/atoms/SelectWithLabels/SelectWithLabels';
import Availability from '../../kit/atoms/Availability/Availability';
import { AvailibilityOption, SortOption, LimiterOption } from '../../types';

export interface ToolbarTopDesktopProps {
    sortingOptions?: SortOption[];
    limiterOptions?: LimiterOption[];
    totalResults?: number;
    filteredAvailabilityOptions?: string[];
    availabilityOptions?: AvailibilityOption[];
    currentLimit: string;
    currentSorting: string;
    currentOrder: string;
    onLimiterChange: (selectedValue: string) => void;
    onSortingChange: (option) => void;
    handleAvailabilityOptions: (options: string[]) => void;
}

const ToolbarTopDesktop: React.FC<ToolbarTopDesktopProps> = ({
    sortingOptions,
    limiterOptions,
    filteredAvailabilityOptions,
    availabilityOptions,
    handleAvailabilityOptions,
    onLimiterChange,
    onSortingChange,
    currentLimit,
    totalResults,
    currentSorting,
    currentOrder
}) => {
    const st: CssModuleType = currentCssModule;
    const { t } = useTranslation();

    return (
        <div className={st.toolbar}>
            <div className={st['toolbar__sorting']}>
                <SelectWithLabels
                    options={sortingOptions}
                    beforeLabel={t('/Search/SortBy')}
                    onChange={onSortingChange}
                    minWidth={true}
                    defaultValue={currentSorting}
                    defaultOrder={currentOrder}
                />
            </div>
            <div className={st['toolbar__center']}>
                <Availability
                    filteredAvailabilityOptions={filteredAvailabilityOptions}
                    availabilityOptions={availabilityOptions}
                    handleAvailabilityOptions={handleAvailabilityOptions}
                />
            </div>
            <div className={st['toolbar__limiter']}>
                <SelectWithLabels
                    options={limiterOptions}
                    beforeLabel={t('/Search/Show')}
                    afterLabel={`${totalResults ? totalResults : ''} ${t(
                        '/Search/Products'
                    )}`}
                    onChange={onLimiterChange}
                    justifyContent='end'
                    defaultValue={currentLimit}
                    defaultOrder={currentOrder}
                />
            </div>
        </div>
    );
};

export default ToolbarTopDesktop;
